import {
  ALERTS_SETTINGS_REQUEST_ASYNC,
  REMOVE_CERTIFICATE_REQUEST_ASYNC,
  UPDATE_ALERTS_SETTINGS_REQUEST_ASYNC,
} from './constants'

const getAlerts = () => ({ type: ALERTS_SETTINGS_REQUEST_ASYNC.INITIATE })
export const getAlertsSuccess = (data) => ({
  type: ALERTS_SETTINGS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getAlertsError = (error) => ({
  type: ALERTS_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const getAlertsCancel = () => ({ type: ALERTS_SETTINGS_REQUEST_ASYNC.CANCEL })

const updAlerts = (data) => ({
  type: UPDATE_ALERTS_SETTINGS_REQUEST_ASYNC.INITIATE,
  payload: { data },
})
export const updAlertsSuccess = (data) => ({
  type: UPDATE_ALERTS_SETTINGS_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const updAlertsError = (error) => ({
  type: UPDATE_ALERTS_SETTINGS_REQUEST_ASYNC.ERROR,
  error,
})
const updAlertsCancel = () => ({
  type: UPDATE_ALERTS_SETTINGS_REQUEST_ASYNC.CANCEL,
})

export const removeCertificate = () => ({
  type: REMOVE_CERTIFICATE_REQUEST_ASYNC.INITIATE,
})
export const removeCertificateSuccess = () => ({
  type: REMOVE_CERTIFICATE_REQUEST_ASYNC.SUCCESS,
})
export const removeCertificateError = (error) => ({
  type: REMOVE_CERTIFICATE_REQUEST_ASYNC.ERROR,
  error,
})

export default {
  // to props
  getAlerts,
  getAlertsCancel,
  updAlerts,
  updAlertsCancel,
  removeCertificate,
}
